import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1 -5 5h-6v-16","key":"svg-0"}]]

/**
 * IconLetterD
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLWQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgNGg2YTUgNSAwIDAgMSA1IDV2NmE1IDUgMCAwIDEgLTUgNWgtNnYtMTYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/letter-d
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterD = createReactComponent('outline', 'letter-d', 'LetterD', __iconNode);

export default IconLetterD;